/*

track events on this site without using inline javascript
make sure you change the URLs in _externalLinks

*/

let Tracking = (function () {

    let gaID = window.gaID;

    let stagingDomain = 'exactgroupni.local';
    let realDomain = 'exactgroupni.com';

    let _downloads =  'a[data-file-download-name]';
    let _external_links =  'a[href^=http], a[href^=mailto], a[href^=tel]';

    let _outboundTrack = function(url) {

        gtag('event', 'Outbound Links', 
        {
          'event_category': url,
          'event_label': window.location.href,
          'transport_type':'beacon',
        });

        setTimeout(function () {
            document.location = url
        },100)
    };

    let _externalLinksAndDownloads = function ()
    {

        $( _external_links ).each(function () {

            if( this.href.indexOf(stagingDomain) == -1 && this.href.indexOf(realDomain) == -1 && this.href.indexOf('mailto:') == -1 && this.href.indexOf('tel:') == -1  ) 
            {
                $( this ).click(function (e) {
                    e.preventDefault();
                    //console.log( this.href, ' outbound tracking' );
                    _outboundTrack(this.href);
                });
            }
            else
            {

                let filetypes = /\.(zip|exe|dmg|pdf|doc.*|xls.*|ppt.*|mp3|txt|rar|wma|mov|avi|wmv|flv|wav)$/i;
                if (this.href.match(filetypes)) 
                {
                    let extension = (/[.]/.exec(href)) ? /[^.]+$/.exec(href) : undefined;
                    if (extension)
                    {
                        $( this ).click(function (e) 
                        {

                            gtag('event', 'Downloads', 
                            {
                              'event_category': this.href,
                              'event_label': window.location.href,
                              'transport_type':'beacon',
                            });
  
                        });                     
                    }
                } 

                if (this.href.match(/^mailto\:/i)) 
                {
                    $( this ).click(function (e) {

                        let label = label = this.href.replace(/^mailto\:/i, '');

                        gtag('event', 'Email', 
                        {
                          'event_category': label,
                          'event_label': window.location.href,
                          'transport_type':'beacon',
                        });


                    });
                }

                if (this.href.match(/^tel\:/i)) 
                {
                    $( this ).click(function (e) {

                        let label = label = this.href.replace(/^tel\:/i, '');

                        gtag('event', 'Telephone', 
                        {
                          'event_category': label,
                          'event_label': window.location.href,
                          'transport_type':'beacon',
                        });

                    });
                }

            }
        });
    };

    let _documentDownloads = function ()
    {
        $( _downloads ).each(function () 
        {
            $( this ).click(function (e) 
            {
                //e.preventDefault();
                let filename = $(this).data( 'file-download-name' );
                let filepath = $(this).data( 'file-download-path' );
                //console.log (filepath, filename, "clicked");

                gtag('event', 'Downloads', 
                {
                  'event_category': filepath,
                  'event_label': window.location.href,
                  'transport_type':'beacon',
                });

            });
        });
    };


    let init = function () 
    {

        if (window.gaID && window.gaID !== undefined && window.gaID !== '' )
        {

            _externalLinksAndDownloads();
            _documentDownloads();
        }
    };

    return {
        init: init,
    }

})();


$( document ).ready( Tracking.init );